export enum MouseButton {
  Left = 0,
  Middle = 1,
  Right = 2,
}

export const DEV_BASE_URL = `http://localhost:3000`;
export const MOBILE_BREAKPOINT_PX = 1024;
export const PROD_HOSTNAME = 'josselinbuils.dev';
export const PROD_BASE_URL = `https://${PROD_HOSTNAME}`;
export const ROOT_FONT_SIZE_PX = 10;
